import Crud from '../views/Pessoa/Crud'
import Entity from '../views/Pessoa/View'

let routes = {
    path: '/pessoas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/pessoas/view/:id?',
            name: 'ViewPessoa',
            component: Entity,
            meta: {
                pageTitle: "Visualizar Pessoa",
                breadcrumb: [
                    {
                        text: "Pessoas",
                        active: false,
                        to: '/pessoas',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/pessoas',
            name: 'list-pessoas',
            component: Crud,
            meta: {
                pageTitle: "Lista de Pessoas",
                breadcrumb: [
                    {
                        text: "Pessoas",
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
